export const getCompletedService = (data) => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();
  const currentDay = currentDate.getDate();

  const result = {
    currentMonth: {
      count: 0,
      ids: [],
    },
    currentDay: {
      count: 0,
      ids: [],
    },
  };

  data.forEach((item) => {
    if (item.repair) {
      result.currentMonth.count += 1;
      result.currentMonth.ids.push(item.id);
      return;
    }

    if (!item.last_to) return;

    const [day, month, year] = item.last_to.split(".").map(Number);

    if (year === currentYear && month === currentMonth + 1) {
      result.currentMonth.count += 1;
      result.currentMonth.ids.push(item.id);
    }

    if (year === currentYear && month === currentMonth + 1 && day === currentDay) {
      result.currentDay.count += 1;
      result.currentDay.ids.push(item.id);
    }
  });

  const completionPercentage = (result.currentMonth.count / data.length) * 100 || 0;
  result.completionPercentage = completionPercentage.toFixed(1);

  const remainingCount = data.length - result.currentMonth.count || 0;
  result.remainingCount = remainingCount;

  return result;
};
